import React from 'react';

const ZoomInIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='23'
      fill='none'
      stroke='#6b6b6b'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      className='feather feather-plus-circle'
      viewBox='0 0 24 24'
    >
      <circle cx='12' cy='12' r='10'></circle>
      <path d='M12 8L12 16'></path>
      <path d='M8 12L16 12'></path>
    </svg>
  );
};

export default ZoomInIcon;
